import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Fourfiveseaterbusonrentinpune() {



  const cardData = {
"keyword": "45 Seater Bus on Rent in Pune",

"headingDescription":
  "Aaradhya Travels offers dependable 45 Seater Bus on Rent in Pune for large group travel including corporate tours, weddings, school and college trips, pilgrimage journeys, and outstation vacations. Our spacious AC buses with pushback seating, ample luggage space, and experienced drivers ensure safe, comfortable, and budget-friendly travel across Pune and Maharashtra.",

"topPlaces": [
 
  {
    "title": "Mahabaleshwar",
    "description":
      "Mahabaleshwar is one of Maharashtra’s top hill stations known for strawberry farms, Venna Lake, viewpoints, waterfalls, and cool climate. It is ideal for large group vacations, corporate tours, and sightseeing trips from Pune."
  },
  {
    "title": "Panchgani",
    "description":
      "Panchgani is known for Table Land, strawberry farms, scenic valleys, boarding schools, and refreshing climate. It is a popular destination for school trips, family tours, and group travel from Pune."
  },
  {
    "title": "Shirdi",
    "description":
      "Shirdi is a major pilgrimage destination dedicated to Sai Baba attracting devotees from across India. Large groups frequently travel in 45 seater buses for comfortable temple darshan and spiritual tours."
  },
  {
    "title": "Nashik",
    "description":
      "Nashik is famous for Trimbakeshwar Temple, vineyards, river ghats, and religious tourism. It is a popular destination for pilgrimage groups and sightseeing tours from Pune using 45 seater buses."
  },
  {
    "title": "Mumbai",
    "description":
      "Mumbai is a major metro city known for Marine Drive, Gateway of India, beaches, shopping streets, Bollywood attractions, nightlife, and corporate hubs. It is a common destination for large group bus travel from Pune."
  },
   {
    "title": "Lonavala",
    "description":
      "Lonavala is a famous hill station near Pune known for waterfalls, green valleys, Tiger Point, Bhushi Dam, caves, and scenic monsoon drives. It is one of the most popular destinations for large group travel using 45 seater buses for family outings, corporate picnics, and weekend tours."
  },
  {
    "title": "Khandala",
    "description":
      "Khandala is a scenic hill destination known for misty mountains, valleys, waterfalls, and peaceful natural surroundings. Large groups prefer 45 seater bus travel for comfortable hill station journeys and sightseeing tours from Pune."
  },
  {
    "title": "Goa",
    "description":
      "Goa is India’s top holiday destination famous for beaches, nightlife, water sports, churches, seafood, and resorts. Friends groups and corporate teams often book 45 seater buses for long-distance road trips from Pune."
  },
  {
    "title": "Lavasa",
    "description":
      "Lavasa is a planned hill city near Pune known for lakeside views, colorful architecture, cafes, and adventure activities. It is a popular one-day and weekend group outing destination."
  },
  {
    "title": "Sinhagad Fort",
    "description":
      "Sinhagad Fort is a historic fort near Pune known for trekking, monsoon views, and Maratha history. It is a popular day-trip destination for student groups and tourists."
  },
  {
    "title": "Aga Khan Palace",
    "description":
      "Aga Khan Palace is an important historical monument associated with Mahatma Gandhi and India’s freedom movement. It is commonly included in educational and sightseeing group tours."
  },
  
],



services: [
  {
    name: "45 Seater Bus for Hire for Outstation",
    description: "45 seater bus for hire for outstation service provides spacious and comfortable transportation for family vacations, pilgrimage journeys, tourist travel, educational tours, and long-distance group trips. Well-maintained buses ensure smooth highway travel suitable for large passenger groups and outstation routes. Professional chauffeurs ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient outstation bus reservations."
  },
  {
    name: "45 Seater Bus for Wedding for Outstation Pune",
    description: "45 seater bus for wedding for outstation Pune service offers luxurious transportation for wedding guests, family members, bridal parties, and marriage event travel requirements. Spacious seating and elegant interiors ensure smooth travel experiences suitable for wedding ceremonies and celebrations. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the wedding schedule. Pickup services are available from homes, banquet halls, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient wedding bus reservations."
  },
  {
    name: "45 Seater AC Bus for Hire",
    description: "45 seater AC bus for hire service provides premium air-conditioned transportation for corporate travel, sightseeing tours, family vacations, weddings, and outstation journeys. Comfortable seating and cooling systems ensure pleasant travel experiences suitable for all weather conditions. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient AC bus reservations."
  },
  {
    name: "45 Seater Non AC Bus for Hire",
    description: "45 seater non AC bus for hire service offers economical transportation for educational tours, local sightseeing, family outings, office trips, and budget-friendly group journeys. Spacious interiors ensure comfortable seating suitable for large passenger groups and short-distance travel. Professional drivers ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, schools, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient non AC bus reservations."
  },
  {
    name: "45 Seater AC Bus for Marriage Function",
    description: "45 seater AC bus for marriage function service provides luxurious transportation for wedding guests, relatives, bridal parties, and family members attending marriage ceremonies. Spacious air-conditioned seating ensures comfortable travel suitable for long wedding schedules and event transportation. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the wedding function. Pickup services are available from homes, hotels, banquet halls, railway stations, and airports across Pune. Flexible booking options allow convenient marriage bus reservations."
  },
  {
    name: "45 Seater Bus for Corporate Events",
    description: "45 seater bus for corporate events service offers professional transportation for business conferences, office meetings, employee travel, industrial visits, and company outings. Spacious buses ensure comfortable travel experiences suitable for executive teams and corporate passengers. Professional drivers ensure safe driving and punctual pickup services throughout the route. Pickup services are available from IT parks, offices, hotels, airports, and commercial locations across Pune. Flexible booking options allow convenient corporate event bus reservations."
  },
  {
    name: "45 Seater Bus on Rent in Pimpri Chinchwad",
    description: "45 seater bus on rent in Pimpri Chinchwad service provides reliable transportation for airport transfers, educational tours, family functions, office outings, and outstation journeys from Pimpri Chinchwad Pune. Spacious buses ensure comfortable seating and smooth travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and commercial areas across Pimpri Chinchwad Pune. Flexible booking options allow convenient bus reservations."
  },
  {
    name: "45 Seater Bus Hire for School Picnic",
    description: "45 seater bus hire for school picnic service offers safe and spacious transportation for educational tours, student outings, school travel, and one-day picnic trips. Comfortable seating and smooth highway performance ensure pleasant travel experiences suitable for students, teachers, and educational groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from schools, colleges, coaching institutes, homes, and educational campuses across Pune. Flexible booking options allow convenient school picnic bus reservations."
  },
  {
    name: "45 Seater Bus Rental for Marriage Function",
    description: "45 seater bus rental for marriage function service provides comfortable transportation for wedding guests, family gatherings, reception events, and marriage celebrations. Spacious seating and elegant interiors ensure smooth travel experiences suitable for large family groups and wedding ceremonies. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the wedding schedule. Pickup services are available from homes, hotels, banquet halls, railway stations, and airport terminals across Pune. Flexible booking options allow convenient marriage bus reservations."
  },
  {
    name: "45 Seater Bus Rent for Corporate Picnic",
    description: "45 seater bus rent for corporate picnic service offers dependable transportation for office outings, team-building activities, employee recreational trips, and company picnic travel. Spacious buses ensure comfortable journeys suitable for business teams and large office groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from IT parks, offices, hotels, and commercial areas across Pune. Flexible booking options allow convenient corporate picnic bus reservations."
  },
  {
    name: "45 Seater Bus for Outstation from Pune",
    description: "45 seater bus for outstation from Pune service provides reliable long-distance transportation for family vacations, pilgrimage tours, tourist travel, educational trips, and sightseeing journeys. Spacious seating and luggage space ensure smooth highway travel suitable for large passenger groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient outstation bus reservations."
  },
  {
    name: "45 Seater Bus Rental Services in Pune",
    description: "45 seater bus rental services in Pune provide comfortable transportation for weddings, educational tours, airport transfers, office outings, tourist travel, and family functions. Spacious interiors and smooth highway performance ensure pleasant travel experiences suitable for all passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient bus rental reservations."
  },
  {
    name: "45 Seater Bus Rental Services in Hadapsar",
    description: "45 seater bus rental services in Hadapsar provide dependable transportation for corporate travel, family outings, educational tours, airport transfers, and outstation journeys from Hadapsar Pune. Spacious buses ensure comfortable seating and smooth travel experiences suitable for group passengers. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and commercial areas across Hadapsar Pune. Flexible booking options allow convenient bus reservations."
  },
  {
    name: "45 Seater Bus Rental for Wedding in Pune",
    description: "45 seater bus rental for wedding in Pune service offers luxurious transportation for marriage ceremonies, bridal parties, guest travel, and family events. Spacious seating and premium interiors ensure smooth travel experiences suitable for wedding celebrations and group transportation. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the event schedule. Pickup services are available from homes, banquet halls, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient wedding bus reservations."
  },
  {
    name: "45 Seater Bus for Company Picnic",
    description: "45 seater bus for company picnic service provides spacious transportation for employee outings, office trips, team-building activities, and recreational travel requirements. Comfortable seating and smooth highway travel ensure pleasant journeys suitable for large office groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from offices, IT parks, hotels, and commercial areas across Pune. Flexible booking options allow convenient company picnic bus reservations."
  },
  {
    name: "45 Seater Bus for Airport Transfer",
    description: "45 seater bus for airport transfer service offers dependable transportation for tourist groups, business passengers, wedding guests, and family travel to and from airport terminals. Spacious seating and luggage capacity ensure comfortable airport journeys suitable for large passenger groups. Professional drivers ensure timely airport pickups and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient airport bus reservations."
  },
  {
    name: "45 Seater Bus for Family Trip",
    description: "45 seater bus for family trip service provides comfortable transportation for holiday vacations, sightseeing tours, pilgrimage journeys, and outstation travel with large family groups. Spacious seating and luggage space ensure smooth travel experiences suitable for long-distance and local family journeys. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, railway stations, airports, and residential areas across Pune. Flexible booking options allow convenient family trip bus reservations."
  },
  {
    name: "45 Seater Bus for Pune Darshan",
    description: "45 seater bus for Pune Darshan service offers reliable transportation for local sightseeing tours, educational visits, tourist travel, and city darshan trips across Pune attractions. Spacious buses ensure comfortable seating suitable for group travel and city tour requirements. Professional chauffeurs ensure safe driving and dependable transportation services throughout the Pune Darshan route. Pickup services are available from homes, hotels, railway stations, airports, and commercial areas across Pune. Flexible booking options allow convenient Pune Darshan bus reservations."
  },
  {
    name: "45 Seater Bus for Corporate Travel",
    description: "45 seater bus for corporate travel service provides professional transportation for employee movement, business conferences, industrial visits, office meetings, and executive travel requirements. Spacious buses ensure comfortable travel experiences suitable for corporate teams and office staff. Professional drivers ensure safe driving and punctual pickup services throughout the route. Pickup services are available from IT parks, offices, hotels, airports, and commercial locations across Pune. Flexible booking options allow convenient corporate travel bus reservations."
  },
  {
    name: "45 Seater Bus for Outstation Tours",
    description: "45 seater bus for outstation tours service offers dependable transportation for Goa tours, Mahabaleshwar trips, Konkan Darshan, pilgrimage journeys, and tourist travel from Pune. Spacious seating and luggage space ensure smooth highway journeys suitable for large travel groups and sightseeing tours. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient outstation tour bus reservations."
  }
],

tableData: [
  ["45 Seater Bus for Hire for Outstation", "45 Seater Bus for Wedding for Outstation Pune"],
  ["45 Seater AC Bus for Hire", "45 Seater Non AC Bus for Hire"],
  ["45 Seater AC Bus for Marriage Function", "45 Seater Bus for Corporate Events"],
  ["45 Seater Bus on Rent in Pimpri Chinchwad", "45 Seater Bus Hire for School Picnic"],
  ["45 Seater Bus Rental for Marriage Function", "45 Seater Bus Rent for Corporate Picnic"],
  ["45 Seater Bus for Outstation from Pune", "45 Seater Bus Rental Services in Pune"],
  ["45 Seater Bus Rental Services in Hadapsar", "45 Seater Bus Rental for Wedding in Pune"],
  ["45 Seater Bus for Company Picnic", "45 Seater Bus for Airport Transfer"],
  ["45 Seater Bus for Family Trip", "45 Seater Bus for Pune Darshan"],
  ["45 Seater Bus for Corporate Travel", "45 Seater Bus for Outstation Tours"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable 45 Seater Bus on Rent in Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable 45 seater bus rental service in Pune with comfortable vehicles, professional drivers, and smooth travel arrangements for corporate events, school tours, weddings, and large group travel."
      },
      {
        WhyChooseheading: "Affordable 45 Seater Bus Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable 45 seater bus on rent in Pune with transparent pricing, flexible booking plans, and complete travel assistance without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Bus Booking Service in Pune",
        WhyChoosedescription: "Our 45 seater bus rental service in Pune operates 24 hours for airport transfers, employee transportation, educational tours, pilgrimage journeys, family functions, and outstation travel."
      },
      {
        WhyChooseheading: "Comfortable & Fully AC 45 Seater Buses",
        WhyChoosedescription: "All 45 seater buses provided by Aaradhya Travels are spacious, air-conditioned, clean, and regularly maintained to provide safe and comfortable travel experiences for large groups."
      },
      {
        WhyChooseheading: "Customized One Day & Multi-Day Tours",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day tours, weekend trips, multi-day outstation journeys, and flexible travel packages according to customer travel requirements."
      },
      {
        WhyChooseheading: "Ideal for Large Group & Corporate Travel",
        WhyChoosedescription: "The 45 seater bus is ideal for corporate teams, school and college groups, wedding guest transportation, tourist groups, industrial visits, and family vacations from Pune."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides doorstep pickup from Pune Airport, railway stations, hotels, homes, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Long Distance Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local and outstation group transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is 45 seater bus on rent in Pune?", answer: "45 seater bus rental service in Pune provides comfortable group transportation for corporate travel, school tours, weddings, family trips, and outstation journeys." },
    { question: "Is 45 seater bus booking available 24 hours?", answer: "Yes, Aaradhya Travels provides 24/7 45 seater bus rental service in Pune." },
    { question: "Can I book 45 seater bus for outstation travel?", answer: "Yes, customers can book 45 seater buses for outstation tours, pilgrimage journeys, hill station trips, and holiday travel." },
    { question: "Do you provide 45 seater buses for corporate events?", answer: "Yes, Aaradhya Travels provides 45 seater bus rental service for corporate meetings, office outings, conferences, and employee transportation." },
    { question: "Are all 45 seater buses air-conditioned?", answer: "Yes, all 45 seater buses are fully air-conditioned and maintained for comfortable group travel." },
    { question: "Can I book 45 seater bus online in Pune?", answer: "Yes, customers can easily book 45 seater bus rental service online or through phone booking." },
    { question: "Do you provide buses for weddings and educational tours?", answer: "Yes, Aaradhya Travels provides spacious 45 seater buses suitable for weddings, school trips, college tours, and family travel." },
    { question: "Are 45 seater bus rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for 45 seater bus rental?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." },
    { question: "Do you provide pickup from Pune Airport and railway stations?", answer: "Yes, Aaradhya Travels provides pickup and drop services from Pune Airport, railway stations, hotels, and all major Pune locations." }
  ];

 const testimonials = [
  {
    id: 1,
    name: "Mr. Prakash Shinde",
    feedback:
      "We organized a group tour using a 45 Seater bus on rent in Pune, and the experience was very comfortable. The bus was clean, spacious, and handled our large group travel smoothly.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Seema Kulkarni",
    feedback:
      "A 45 Seater bus rental in Pune made our event transportation stress-free. Everyone traveled together comfortably, and the service was punctual and well-managed throughout the journey.",
    rating: 5
  }
];






  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "45 Seater Bus on Rent in Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/45-seater-bus-on-rent-pune.jpg",
  "description": "Book 45 Seater Bus on rent in Pune with Aaradhya Travels for outstation trips, weddings, corporate events, school picnics, airport transfers, and group travel. Affordable AC and Non-AC 45 seater bus rental service available across Pune and Pimpri Chinchwad.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2618"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/45-seater-bus-on-rent-in-pune"
  }
};




  return (
    <div>
<Helmet>
  <title>
    45 Seater Bus on Rent in Pune | AC & Non-AC Bus Hire | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire 45 Seater Bus on rent in Pune with Aaradhya Travels. Affordable AC and Non-AC bus available for outstation travel, weddings, corporate events, school picnics, Pimpri Chinchwad rentals, airport transfers, and group tours."
  />

  <meta
    name="keywords"
    content="45 Seater Bus for Hire for Outstation, 45 seater bus for wedding for outstation pune, 45 Seater ac bus for hire, 45 Seater Non ac bus for hire, 45 Seater ac bus for marriage function, 45 Seater bus for corporate events, 45 seater bus on rent in Pimpri Chinchwad, 45 Seater bus hire for School Picnic"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/14.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Fourfiveseaterbusonrentinpune;